import { UserAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * A page of GoTu Admins, display-ready.
 *
 * @param {Object} [params] - See `clients/GetInternalUsers`.
 * @returns {Promise<import('../types/User').IGetInternalUsersPageResult>}
 */
export const getInternalUsers = async (params) => {
  const response = await UsersApi.getInternalUsers(params);

  return UserAdapters.toGetInternalUsersPageResult(response);
};
